"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _button = _interopRequireDefault(require("@ingka/button"));

var _chevronRight = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right"));

var _chevronLeft = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-left"));

var _ScrollIndicator = _interopRequireDefault(require("./ScrollIndicator"));

var _smoothScroll = _interopRequireDefault(require("@ingka/carousel-shared/utils/smoothScroll"));

var _bezierEasing = _interopRequireDefault(require("bezier-easing"));

var _debounce = _interopRequireDefault(require("@ingka/carousel-shared/utils/debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

class Carousel extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isScrolling: false,
      currentIndex: props.slideIndex,
      visibleSlides: [],
      partiallyVisibleSlides: [],
      targetScroll: 0,
      currentScroll: 0,
      initialized: false,
      draggable: false,
      prevPosition: 0,
      prevSliderPosition: 0,
      slideShowDragging: false,
      intersectionObserverDisabled: false
    };

    if (props.id !== 'default') {
      this.skipButtonId = `${props.prefix}-carousel__${props.id}-skip-btn`;
      this.previousBtnId = `${props.prefix}-carousel__${props.id}-prev-btn`;
      this.nextBtnId = `${props.prefix}-carousel__${props.id}-next-btn`;
    } else {
      this.skipButtonId = `${props.prefix}carousel-${Math.random().toString(36).substring(2)}__skip-btn`;
      this.previousBtnId = `${props.prefix}carousel-${Math.random().toString(36).substring(2)}__prev-btn`;
      this.nextBtnId = `${props.prefix}carousel-${Math.random().toString(36).substring(2)}__next-btn`;
    }

    this._visibleSlides = [];
    this._partiallyVisibleSlides = [];
    this._visibleSlidesLength = null;
    this.onKeyUp = this.onKeyUp.bind(this);
    this.observeSlides = this.observeSlides.bind(this);
    this.setScrollState = this.setScrollState.bind(this);
    this.onScrollIndicatorClick = this.onScrollIndicatorClick.bind(this);
    this.slideRefs = [];
    this.onButtonClick = this.onButtonClick.bind(this);
    this.handleScrollBarMouseMove = this.handleScrollBarMouseMove.bind(this);
    this.handleScrollBarMouseDown = this.handleScrollBarMouseDown.bind(this);
    this.handleScrollBarMouseUp = this.handleScrollBarMouseUp.bind(this);
    this.handleSwipe = this.handleSwipe.bind(this);

    if (_react.createRef) {
      this.component = (0, _react.createRef)();
      this.container = (0, _react.createRef)();
      this.scroller = (0, _react.createRef)();
      this.slider = (0, _react.createRef)();
      this.scrollIndicator = (0, _react.createRef)();
    }
  }

  clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
  }

  setScrollState() {
    this.setState({
      currentScroll: this.scroller.scrollLeft
    });
  }

  observeSlides(entries, observer) {
    entries.forEach(entry => {
      const validObserver = observer && observer.thresholds;

      if (validObserver && entry.intersectionRatio >= observer.thresholds[1]) {
        if (this._visibleSlides.indexOf(entry.target) === -1) {
          this._visibleSlides.push(entry.target);
        }
      } else {
        this._visibleSlides = this._visibleSlides.filter(item => item !== entry.target);
      }

      if (validObserver && entry.intersectionRatio >= observer.thresholds[0]) {
        if (this._partiallyVisibleSlides.indexOf(entry.target) === -1) {
          this._partiallyVisibleSlides.push(entry.target);
        }
      } else {
        this._partiallyVisibleSlides = this._partiallyVisibleSlides.filter(item => item !== entry.target);
      }

      this.debouncedSetVisibilityState(this._visibleSlides);
      this.setState({
        partiallyVisibleSlides: this._partiallyVisibleSlides
      });
      this.partiallyVisibleIndexes = this._partiallyVisibleSlides.map(visible => this.slideRefs.indexOf(visible));
    });
  }

  _getVisibleMinMax(indexes, minmax) {
    if (indexes === undefined || indexes.length === 0) {
      return null;
    }

    return Math[minmax].apply(Math, indexes);
  }

  get maxVisible() {
    return this._getVisibleMinMax(this.visibleIndexes, 'max');
  }

  get maxPartiallyVisible() {
    return this._getVisibleMinMax(this.partiallyVisibleIndexes, 'max');
  }

  get minVisible() {
    return this._getVisibleMinMax(this.visibleIndexes, 'min');
  }

  get minPartiallyVisible() {
    return this._getVisibleMinMax(this.partiallyVisibleIndexes, 'min');
  }

  get firstSlide() {
    return this.slideRefs.length > 0 ? this.slideRefs[0] : null;
  }

  get lastSlide() {
    return this.slideRefs.length > 0 ? this.slideRefs[this.lastSlideIndex] : null;
  }

  get isFirstSlideVisible() {
    (0, _debounce.default)(() => {
      if (this.state.currentScroll === 0) {
        return true;
      }
    }, 100);

    if (this._visibleSlides.indexOf(this.firstSlide) > -1) {
      return true;
    }

    return false;
  }

  get isLastSlideVisible() {
    (0, _debounce.default)(() => {
      if (this.state.currentScroll === this.maxScrollWidth) {
        return true;
      }
    }, 100);

    if (this._visibleSlides.indexOf(this.lastSlide) > -1) {
      return true;
    }

    return false;
  }

  get allSlidesVisible() {
    return this.isFirstSlideVisible && this.isLastSlideVisible;
  }

  get lastSlideIndex() {
    return this.slideRefs.length - 1;
  }

  get nextSlide() {
    if (this.maxVisible === null) {
      return this.maxPartiallyVisible;
    }

    return this.maxVisible + 1;
  }

  get prevSlide() {
    if (this.minVisible === null) {
      return this.minPartiallyVisible;
    }

    return this.minVisible - 1;
  }

  get visibleSlidesLength() {
    if (this._visibleSlidesLength) {
      return this._visibleSlidesLength;
    }

    return this.clamp(this.state.visibleSlides.length, 1, Infinity);
  }

  get scrollWidth() {
    if (!this.scroller) {
      return Infinity;
    }

    return this.scroller.scrollWidth;
  }

  get maxScrollWidth() {
    if (!this.scroller) {
      return Infinity;
    }

    return this.scrollWidth - this.scroller.offsetWidth;
  }

  getPreviousScroll(target) {
    return !this.props.isSlideShow && this.props.rtl ? target.offsetLeft : target.offsetLeft + target.getBoundingClientRect().width - this.scroller.offsetWidth;
  }

  getNextScroll(target) {
    return !this.props.isSlideShow && this.props.rtl ? target.offsetLeft - this.scroller.offsetWidth + target.getBoundingClientRect().width : target.offsetLeft;
  }

  onButtonClick(direction) {
    if (this.state.isScrolling) {
      return;
    }

    const nextSlide = this.clamp(direction === 'right' ? this.nextSlide : this.prevSlide, 0, this.lastSlideIndex);
    this.goToIndex(nextSlide, direction);

    if (direction === 'right' && this.props.onBtnRightClick) {
      this.props.onBtnRightClick();
    }

    if (direction === 'left' && this.props.onBtnLeftClick) {
      this.props.onBtnLeftClick();
    }
  }

  goToIndex(index, direction) {
    index = this.clamp(index, 0, this.lastSlideIndex);
    const nextSlideElement = this.slideRefs[index];

    if (!nextSlideElement) {
      this.scrollTo(0);
      return;
    }

    const newScroll = direction === 'right' ? this.getNextScroll(nextSlideElement) : this.getPreviousScroll(nextSlideElement);
    let targetScroll = newScroll;

    if (index === 0) {
      targetScroll = 0;
    }

    this.scrollTo(targetScroll);
  }

  easing(elapsed, offset, gap, duration) {
    const f = (0, _bezierEasing.default)(0.4, 0, 0.4, 1);
    const progress = elapsed / duration;
    return gap * f(progress) + offset;
  }

  scrollTo(targetScroll) {
    this.setState({
      targetScroll
    });
    this.stopObservingSlides();

    if (!this.state.initialized || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.scroller.scrollLeft = targetScroll;
      this.startObservingSlides();

      if (!this.state.initialized) {
        this.setState({
          initialized: true
        });
      }

      return;
    }

    this.setState({
      isScrolling: true
    });
    (0, _smoothScroll.default)(this.scroller, 'scrollLeft', targetScroll, this.easing, 200, () => {
      this.setState({
        isScrolling: false
      });
      this.startObservingSlides();
    });
  }

  startObservingSlides() {
    this.setState({
      slideShowDragging: false
    });

    if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
      this.visibleSlideObserver = new IntersectionObserver(this.observeSlides, {
        root: this.scroller,
        threshold: [0.99, 0.001],
        margin: '1px'
      });
      this.slideRefs.forEach(slide => !!slide && this.visibleSlideObserver.observe(slide));
      this.setState({
        intersectionObserverDisabled: false
      });
    } else {
      this.setState({
        intersectionObserverDisabled: true
      });
    }
  }

  stopObservingSlides() {
    if (this.visibleSlideObserver) {
      this.visibleSlideObserver.disconnect();
    }
  }

  onKeyUp(e) {
    let arrowKey;

    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();

      switch (e.key) {
        case 'ArrowLeft':
          arrowKey = this.props.rtl ? 'right' : 'left';
          break;

        case 'ArrowRight':
          arrowKey = this.props.rtl ? 'left' : 'right';
          break;

        default:
          return;
      }

      this.onButtonClick(arrowKey);
    }
  }

  onScrollIndicatorClick(e) {
    if (!this.scrollIndicator) {
      return;
    }

    const {
      children,
      isSlideShow
    } = this.props;
    const numberOfItems = children.length;

    if (e.target === this.scrollIndicator.childNodes[0]) {
      return;
    }

    const scrollIndicatorLeftOffset = this.scrollIndicator.getBoundingClientRect().left;
    const scrollIndicatorWidth = this.scrollIndicator.getBoundingClientRect().width;
    const clickedPointInPercentage = (e.clientX - scrollIndicatorLeftOffset) * 100 / scrollIndicatorWidth;
    const clickedPoint = clickedPointInPercentage * this.maxScrollWidth / 100;

    if (isSlideShow) {
      const scrollPointsDistance = this.maxScrollWidth / (numberOfItems - 1);
      const stepWidth = this.maxScrollWidth / numberOfItems;
      let newScrollPosition = Math.round(clickedPoint / scrollPointsDistance) * scrollPointsDistance;

      if (clickedPoint < stepWidth) {
        newScrollPosition = 0;
      } else if (clickedPoint > stepWidth * (numberOfItems - 1)) {
        newScrollPosition = this.maxScrollWidth;
      }

      this.scrollTo(this.props.rtl ? newScrollPosition - this.maxScrollWidth : newScrollPosition);
    } else {
      this.scrollTo(this.props.rtl ? clickedPoint - this.maxScrollWidth : clickedPoint);
    }
  }

  adjustSliderPosition() {
    this.goToIndex(this.state.currentIndex);
  }

  handleSwipe() {
    if (!this.state.slideShowDragging) return;
    requestAnimationFrame(() => {
      this.setState({
        slideShowDragging: false
      });
    });
  }

  handleScrollBarMouseDown(e) {
    this.setState({
      draggable: true,
      prevPosition: e.pageX,
      prevSliderPosition: this.scroller.scrollLeft,
      slideShowDragging: true
    });
  }

  handleScrollBarMouseUp() {
    this.setState({
      draggable: false
    });
  }

  handleScrollBarMouseMove(e) {
    if (!this.state.draggable) return;
    const stepRatio = this.scrollWidth / this.scrollIndicator.scrollWidth;
    this.scroller.scrollLeft = this.state.prevSliderPosition + (e.pageX - this.state.prevPosition) * stepRatio;
  }

  componentDidMount() {
    this.resizeEventCallback = (0, _debounce.default)(() => {
      this._visibleSlidesLength = this._visibleSlides ? this._visibleSlides.length : null;
      this.props.onResize && this.props.onResize();
      this.stopObservingSlides();
      this.startObservingSlides();

      if (!!this.slideRefs[0] && this.slideRefs[0].getBoundingClientRect().width * this.slideRefs.length <= this.scroller.offsetWidth) {
        this.adjustSliderPosition();
      }
    }, 250);
    window.addEventListener('mousemove', this.handleScrollBarMouseMove);
    window.addEventListener('mouseup', this.handleScrollBarMouseUp);
    window.addEventListener('resize', this.resizeEventCallback);
    this.scroller.addEventListener('wheel', this.handleSwipe);
    this.scroller.addEventListener('scroll', this.setScrollState);
    this.debouncedSetVisibilityState = (0, _debounce.default)(visibleSlides => {
      if (!this._visibleSlidesLength) {
        this._visibleSlidesLength = visibleSlides.length;
      }

      this.setState({
        visibleSlides
      });
      this.visibleIndexes = visibleSlides.map(visible => this.slideRefs.indexOf(visible));
    }, 100);
    this.startObservingSlides();
    this.adjustSliderPosition();
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleScrollBarMouseMove);
    window.removeEventListener('mouseup', this.handleScrollBarMouseUp);
    window.removeEventListener('resize', this.resizeEventCallback);
    this.scroller.removeEventListener('wheel', this.handleSwipe);
    this.scroller.removeEventListener('scroll', this.setScrollState);
    this.stopObservingSlides();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.slideIndex !== prevProps.slideIndex) {
      this.goToIndex(this.props.slideIndex, prevState.currentIndex);
    }
  }

  render() {
    const {
      id,
      slideIndex,
      hasNoControls,
      children,
      prefix,
      rtl,
      ariaLabelLeftBtn,
      ariaLabelRightBtn,
      controlBtnType,
      onBtnRightClick,
      onBtnLeftClick,
      onResize,
      itemClass,
      contentClass,
      bodyWrapperClass,
      isSlideShow,
      hasNoScrollbar,
      className,
      skipButtonText,
      ...otherProps
    } = this.props;
    const {
      currentScroll,
      isScrolling,
      slideShowDragging,
      draggable
    } = this.state;
    const isLastSlide = this.isLastSlideVisible;
    const isFirstSlide = this.isFirstSlideVisible;
    const isSingleSlide = this.allSlidesVisible;
    const scrollPercent = currentScroll / this.maxScrollWidth * 100;
    const scrollIndicatorWidth = this.scroller.offsetWidth / this.scroller.scrollWidth * 100;

    const childrenAsArray = _react.default.Children.toArray(children).filter(c => c);

    let wrappedChildren = childrenAsArray.map((child, i) => {
      return _react.default.createElement("div", {
        ref: el => this.slideRefs[i] = el,
        className: (0, _classnames.default)(`${prefix}carousel-slide`, itemClass),
        key: `${id}-${i}`
      }, child);
    });
    const carouselClasses = (0, _classnames.default)(`${prefix}carousel`, className, isSlideShow && `${prefix}carousel__slide-show`, this.state.intersectionObserverDisabled && `${prefix}carousel--intersection-observer-disabled`, draggable && `${prefix}carousel--dragging`);
    const carouselContentClasses = (0, _classnames.default)(`${prefix}carousel__content`, contentClass, !isScrolling && `${prefix}carousel__content--snap-slide`, slideShowDragging && `${prefix}carousel__content--drag-slide`, isSingleSlide && `${prefix}carousel__content--single-slide`);
    const carouselBodyClasses = (0, _classnames.default)(`${prefix}carousel__body`, isSlideShow && `${prefix}carousel__body--slide-show`);
    return _react.default.createElement("div", _extends({
      className: carouselClasses,
      tabIndex: "-1",
      ref: this.component
    }, otherProps, {
      onKeyUp: this.onKeyUp
    }), _react.default.createElement(_button.default, {
      className: `${prefix}carousel__skip-button`,
      href: `#${this.skipButtonId}`,
      type: "primary",
      inverseTheme: true
    }, skipButtonText), _react.default.createElement("div", {
      className: `${prefix}carousel__wrapper`,
      ref: this.container
    }, !hasNoControls && _react.default.createElement(_button.default, {
      id: this.previousBtnId,
      "aria-controls": `${prefix}carousel__${id}`,
      prefix: prefix,
      small: true,
      iconOnly: true,
      ssrIcon: _chevronLeft.default,
      type: controlBtnType,
      "aria-label": ariaLabelLeftBtn,
      className: (0, _classnames.default)(`${prefix}carousel__button`, isFirstSlide && `${prefix}carousel__button--hidden`),
      onClick: () => this.onButtonClick('left')
    }), _react.default.createElement("div", {
      className: carouselContentClasses,
      ref: scroller => this.scroller = scroller
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)(`${prefix}carousel__body-wrapper`, bodyWrapperClass)
    }, _react.default.createElement("div", {
      id: `${prefix}carousel__${id}`,
      className: carouselBodyClasses,
      ref: this.slider
    }, wrappedChildren))), !hasNoControls && _react.default.createElement(_button.default, {
      id: this.nextBtnId,
      "aria-controls": `${prefix}carousel__${id}`,
      prefix: prefix,
      small: true,
      iconOnly: true,
      ssrIcon: _chevronRight.default,
      type: controlBtnType,
      "aria-label": ariaLabelRightBtn,
      className: (0, _classnames.default)(`${prefix}carousel__button`, `${prefix}carousel__button--right`, isLastSlide && `${prefix}carousel__button--hidden`),
      onClick: () => this.onButtonClick('right')
    })), !isSingleSlide && !hasNoScrollbar && _react.default.createElement(_ScrollIndicator.default, {
      prefix: prefix,
      barPosition: scrollPercent,
      barWidth: scrollIndicatorWidth,
      ref: el => this.scrollIndicator = el,
      onClick: this.onScrollIndicatorClick,
      onMouseDown: this.handleScrollBarMouseDown,
      draggable: this.state.draggable
    }), _react.default.createElement("a", {
      id: this.skipButtonId
    }));
  }

}

Carousel.defaultProps = {
  id: 'default',
  slideIndex: 0,
  hasNoControls: false,
  children: [],
  prefix: '',
  ariaLabelLeftBtn: 'See previous items',
  ariaLabelRightBtn: 'See next items',
  controlBtnType: 'primary',
  skipButtonText: 'Skip listing',
  onBtnRightClick: () => {},
  onBtnLeftClick: () => {},
  contentClass: '',
  bodyWrapperClass: '',
  itemClass: ''
};
var _default = Carousel;
exports.default = _default;